import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2577c3f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { action: "" }
const _hoisted_2 = { class: "search-history" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "搜索历史：", -1))
const _hoisted_4 = { class: "search-tags" }
const _hoisted_5 = ["onClick"]

import { ref } from 'vue'
import { Toast } from 'vant'

import { getShopByName } from '@/api/shop'


export default /*#__PURE__*/_defineComponent({
  props: {
  margin: Number,
  default() {
    return 0
  }
},
  emits: ['handle'],
  setup(__props, { emit }) {

const props = __props



const value = ref<string>('')
const searchs = ref(JSON.parse(localStorage.getItem('searchs') || '[]'))

const delHistory = () => {
  localStorage.setItem('searchs', '[]')
  searchs.value = []
}

const toSearch = (val: string) => {
  value.value = val
  onSearch(val)
}

const onSearch = (val: string) => {
  Toast.loading({
    message: '搜索中...',
    forbidClick: true
  })
  if (!value.value.trim()) {
    emit('handle')
    return
  }
  getShopByName({
    storeName: value.value,
    size: 30
  }).then((res: any) => {
    if (res) {
      emit('handle', res)
    } else {
      Toast.fail('暂无结果')
    }
    if (!searchs.value.includes(value.value)) {
      searchs.value.push(value.value)
      localStorage.setItem('searchs', JSON.stringify(searchs.value))
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_van_search = _resolveComponent("van-search")!

  return (_openBlock(), _createElementBlock("div", {
    class: "search-wrapper",
    style: _normalizeStyle({ marginTop: `${props.margin}px` })
  }, [
    _createElementVNode("form", _hoisted_1, [
      _createVNode(_component_van_search, {
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        shape: "round",
        background: "#fff",
        placeholder: "输入门店名称进行搜索...",
        "left-icon": "",
        "right-icon": "search",
        onSearch: onSearch,
        onClickRightIcon: onSearch
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { class: "search-history-head" }, [
        _hoisted_3,
        _createElementVNode("i", {
          class: "iconfont icon-shanchu",
          onClick: delHistory
        })
      ]),
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchs.value, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            onClick: ($event: any) => (toSearch(item))
          }, _toDisplayString(item), 9, _hoisted_5))
        }), 128))
      ])
    ])
  ], 4))
}
}

})